import {View} from "@lernetz/ts-lib";
import template from "./MagicWand.component.html";

export const MagicWand = new View({template})

